import { Box, Button, Tooltip } from '@mantine/core';
import { IconNews } from '@tabler/icons-react';
import { useEffect, type FC } from 'react';
import useHeadway from '../../hooks/thirdPartyServices/useHeadway';
import useApp from '../../providers/App/useApp';
import useTracking from '../../providers/Tracking/useTracking';
import { EventName } from '../../types/Events';
import MantineIcon from '../common/MantineIcon';
import classes from './HeadwayMenuItem.module.css';

type Props = {
    projectUuid?: string;
    withLabel?: boolean;
};

const HeadwayMenuItem: FC<Props> = ({ projectUuid, withLabel = false }) => {
    const { track } = useTracking();
    const { user } = useApp();
    const isHeadwayloaded = useHeadway();

    useEffect(() => {
        if (!projectUuid || !isHeadwayloaded) return;

        const trackNotifications = {
            user_id: user.data?.userUuid,
            project_id: projectUuid,
            organization_id: user.data?.organizationUuid,
        };

        (window as any)?.Headway?.init({
            selector: '#headway-badge',
            trigger: '#headway-trigger',
            account: 'xav2g7',
            callbacks: {
                onShowWidget: () => {
                    track({
                        name: EventName.NOTIFICATIONS_CLICKED,
                        properties: { ...trackNotifications },
                    });
                },
                onShowDetails: (changelog: any) => {
                    track({
                        name: EventName.NOTIFICATIONS_ITEM_CLICKED,
                        properties: {
                            ...trackNotifications,
                            item: changelog.title,
                        },
                    });
                },
                onReadMore: () => {
                    track({
                        name: EventName.NOTIFICATIONS_CLICKED,
                        properties: { ...trackNotifications },
                    });
                },
            },
        });
    }, [
        track,
        projectUuid,
        user.data?.organizationUuid,
        user.data?.userUuid,
        isHeadwayloaded,
    ]);

    if (!isHeadwayloaded || !projectUuid) return null;

    return (
        <Tooltip label="What's new?">
            <Button
                variant="default"
                size="xs"
                pos="relative"
                id="headway-trigger"
                aria-label="What's new?"
            >
                <MantineIcon icon={IconNews} />
                {withLabel && "What's new?"}
                <Box
                    id="headway-badge"
                    pos="absolute"
                    className={classes.badge}
                />
            </Button>
        </Tooltip>
    );
};

export default HeadwayMenuItem;
